import { FC } from 'react'
import IconWrapper, { IconWrapperProps } from './IconWrapper'
import { ReactComponent as MyRejectIcon } from './img/reject.svg'

type RejectIconProps = IconWrapperProps

export const RejectIcon: FC<RejectIconProps> = ({ className, ...props }) => {
  return (
    <IconWrapper className={className} {...props}>
      <MyRejectIcon />
    </IconWrapper>
  )
}
